import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const EMPTY = { ships: [], quotes: [], leads: [], posts: [], apps: [], errors: [] };

export function useAdminData() {
  const [data, setData] = useState(EMPTY);

  const reload = useCallback(async () => {
    try {
      const [s, q, l, b, a, er] = await Promise.all([
        api.get("/admin/shipments"), api.get("/admin/quotes"), api.get("/admin/leads"),
        api.get("/admin/blog"), api.get("/admin/applications"), api.get("/admin/errors"),
      ]);
      setData({ ships: s.data, quotes: q.data, leads: l.data, posts: b.data, apps: a.data, errors: er.data });
    } catch { toast.error("Failed to load admin data."); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { ...data, reload };
}
